/* PACKAGES */
import React from 'react';

/* UTILS */
import { getIndex } from '../../utils/slider';

/* STYLES */
import s from './Slider.module.scss';

const SliderCounter = ({ infinite, totalUniqueSlides, widthSubColumn, totalSubColumns, index }) => {
	const navIndex = getIndex(infinite, totalUniqueSlides, false, widthSubColumn, totalSubColumns, index);

	return (
		<div className={s.sliderCounter}>{ `${navIndex - infinite + 1}/${totalUniqueSlides}` }</div>
	);
};

export default SliderCounter;
